import { styled } from '@mui/material/styles';
import { useCallback, useState } from 'react';
import { Document, Page as PdfPage, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import DocumentSkeleton from './DocumentSkeleton';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const PreviewContainer = styled('div')({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

const PdfScrollContainer = styled('div')({
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
});

const PdfCenterWrapper = styled('div')(({ theme }) => ({
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
}));

type Props = {
  fileUrl?: string | null;
  fileName?: string | null;
  isUploading?: boolean;
  isResizing?: boolean;
};

const InvoicePreview: React.FC<Props> = ({
  fileUrl,
  isUploading,
  isResizing,
}) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [containerWidth, setContainerWidth] = useState<number | undefined>();

  const containerRef = useCallback((node: HTMLDivElement | null) => {
    if (node) setContainerWidth(node.clientWidth);
  }, []);

  if (isUploading) return <DocumentSkeleton showSpinner />;
  if (!fileUrl) return null;
  if (isResizing) return <DocumentSkeleton />;

  return (
    <PreviewContainer>
      <PdfScrollContainer ref={containerRef}>
        <PdfCenterWrapper>
          {containerWidth && (
            <Document
              file={fileUrl}
              loading=""
              onLoadSuccess={({ numPages }) => setNumPages(numPages)}
            >
              {Array.from({ length: numPages ?? 0 }, (_, i) => (
                <PdfPage
                  key={i + 1}
                  pageNumber={i + 1}
                  width={containerWidth}
                />
              ))}
            </Document>
          )}
        </PdfCenterWrapper>
      </PdfScrollContainer>
    </PreviewContainer>
  );
};

export default InvoicePreview;
